import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface Props {
  /** Language codes that HAVE a value (solid). */
  present: string[];
  /**
   * Full set of active language codes. Any active code not in `present` renders
   * faded ("missing") so the gap is visible at a glance. When omitted, only the
   * present codes are shown.
   */
  active?: string[];
}

/**
 * Language coverage badges: present languages are solid, active-but-missing
 * languages are faded. The single source of the "hangi dilde değeri var / eksik"
 * signal, shared by the namespace directory and the namespace manager.
 */
export function LanguageCoverageTags({ present, active }: Props) {
  const { t } = useTranslation('translations');
  const presentSet = new Set(present.map((c) => c.toLowerCase()));
  // Union preserving order: active first (stable), then any present code not in active.
  const codes = active && active.length > 0
    ? Array.from(new Set([...active, ...present]))
    : present;

  if (codes.length === 0) return null;

  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {codes.map((code) => {
        const has = presentSet.has(code.toLowerCase());
        return has ? (
          <Tag key={code} color="blue" style={{ margin: 0, textTransform: 'uppercase' }}>
            {code}
          </Tag>
        ) : (
          <Tooltip key={code} title={t('languageBadge.missing')}>
            <Tag
              style={{ margin: 0, textTransform: 'uppercase', opacity: 0.45, borderStyle: 'dashed' }}
            >
              {code}
            </Tag>
          </Tooltip>
        );
      })}
    </span>
  );
}
